// The Radio chip (docs/APP_REFERENCE.md "Radio"): beside City, Tour and Weather, one tap tunes in to Lofi Cities Radio
// or back out, like the Vibe panel's switch and O. Its small state is pure (tests/radio-chip.test.mjs); app.js sets it.

/**
 * The chip's state text. On: who listens ("23 listening"; "just you" when the one listener is this page, playing), or
 * "on" until the worker says. Off: the hour's show ("jazzhop hour"), with who listens once anyone does
 * ("jazzhop · 3 listening"), or "off" before the player knows the show. `show` is the show's style name, `listeners`
 * the worker's count (null without one), `playing` whether this page's music plays (it counts itself then).
 */
export function radioChipState({ on, show = null, listeners = null, playing = false }) {
  const n = Number.isSafeInteger(listeners) && listeners > 0 ? listeners : null;
  const listening = n && `${n.toLocaleString('en-US')} listening`;
  if (on) return !n ? 'on' : n === 1 && playing ? 'just you' : listening;
  const name = typeof show === 'string' && show ? show.toLowerCase() : null;
  if (!name) return 'off';
  return n ? `${name} · ${listening}` : `${name} hour`;
}
